<app-page-container>
  <app-header appTitle="Documentos" divider>
    <!-- <p class="sub-titulo">Documentos mais atualizados</p> -->
  </app-header>

  <table style="width: 100%; border-collapse: collapse;">
    <thead>
      <tr style="background-color: #333; color: #fff;">
        <th style="padding: 10px; border: 1px solid #333;">Nome do Arquivo</th>
        <th style="padding: 10px; border: 1px solid #333;">Download</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let doc of documento; let i = index" [ngClass]="{'even-row': i % 2 === 0}">
        <td style="padding: 10px; border: 1px solid #333;">{{ doc.fileName }}</td>
        <td style="padding: 10px; border: 1px solid #333;">
          <a [href]="getSafeUrl(doc.contentType, doc.base64Content)" [download]="doc.fileName || 'file'">Download</a>
        </td>
      </tr>
    </tbody>
  </table>
</app-page-container>

<style>
  .even-row {
    background-color: #f9f9f9;
  }

  .odd-row {
    background-color: #fff;
  }
</style>